import {
  MembershipState,
  MembershipStep,
} from "components/Membership/membershipTypes";
import StepBudget from "components/Step/StepBudget";
import { Subscription } from "lib/api/subscription";

export const MembershipStepBudget = ({
  routePrevStep,
  ...state
}: MembershipState) => {
  const backButtonProps = {
    onClick: () => routePrevStep?.(),
  };

  return (
    <StepBudget
      {...state}
      initialValues={state.budgetValues}
      stepFooterProps={{ backButtonProps }}
      stepHeaderProps={{ backButtonProps }}
      subscription={state.subscription as Subscription}
    />
  );
};

export const MEMBERSHIP_STEP_BUDGET: MembershipStep = {
  component: MembershipStepBudget,
  id: "membership-id-budget",
  slug: "budget",
};

export default MEMBERSHIP_STEP_BUDGET;
